export default "__VITE_ASSET__b2b19de3__"